<template>
    <div class="animated revealUp show-refund-wrapper">
        <div class="white-wrapper">
            <div class="section-title">
                Show Refund
            </div>
            <div class="mt-3 mb-2">
                <div class="row">
                    <div class="col-lg-3 col-xl-3 align-self-center mb-3">
                        <div class="input-material">
                            <div class="add-datepicker">
                                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                                    v-validate="'required'"></Datepicker>
                                <label :class="fromDate ? 'active' : ''">
                                    <!-- {{ $t("show") }} -->
                                    {{ $t("fromdate") }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                            <label :class="dropDown.cinemas && dropDown.selectedCinema
                                ? 'shift-up'
                                : ''
                                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
                            <multiselect :disabled="isRoleID" :options="dropDown.cinemas"
                                v-model="dropDown.selectedCinema" :searchable="true" label="cine_name"
                                track-by="cine_id" placeholder="" @input="onSelectCinema($event)" :allowEmpty="false"
                                :showLabels="false"></multiselect>
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                            <label :class="selectedScreen && Object.keys(selectedScreen).length > 0
                                ? 'shift-up'
                                : ''
                                ">Select Screen</label>
                            <multiselect :disabled="isRoleID" :options="screensList" v-model="selectedScreen"
                                :searchable="true" label="screen_name" track-by="screen_id" placeholder=""
                                @input="getshowtimebyMovie()" :allowEmpty="false" :showLabels="false">
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                            <label :class="selectedShowList && Object.keys(selectedShowList).length > 0
                                ? 'shift-up'
                                : ''
                                ">Select Show</label>
                            <multiselect :disabled="isRoleID" :options="showsList" v-model="selectedShowList"
                                :searchable="true" label="movie_name" track-by="ss_id" placeholder=""
                                :allowEmpty="false" :showLabels="false">
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-3 col-xl-3 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                            <label :class="selectedRefundMode && Object.keys(selectedRefundMode).length > 0
                                ? 'shift-up'
                                : ''
                                ">Select Refund Mode</label>
                            <multiselect :disabled="isRoleID" :options="refundApplicablePaymentModes"
                                v-model="selectedRefundMode" :searchable="true" label="pm_payment_mode" track-by="pm_id"
                                placeholder="Refund Mode" :allowEmpty="false" :showLabels="false"
                                @input="setRefundModes($event)">
                            </multiselect>
                        </div>
                    </div>

                    <div class="col-lg-3 col-xl-2 align-self-center mb-3">
                        <button class="btn-blue-lg w-100" @click.prevent="getBookedTransactions()">
                            {{ $t("fetch") }}
                            {{ $t("report") }}
                        </button>
                    </div>
                    <div class="col-lg-3 col-xl-2 align-self-center mb-3" v-if="bookedTransactions.length">
                        <button class="btn-blue-lg w-100" @click.prevent="makeBulkRefunds()">
                            Initiate Refund
                        </button>
                    </div>
                </div>
            </div>
            <div style="overflow-x:scroll;width: auto !important" ref="exportable_table">
                <table class="swc-report-table show_refund_table" border="1"
                    style="table-layout: auto; background: white">
                    <thead class="bg-lightgrey font-weight-bold">
                        <th><b-form-checkbox class="j-checkbox p-2" @input="setAllBookingsRefundStatus($event)"
                                unchecked-value="N" value="Y">To Refund Booking Code</b-form-checkbox></th>
                        <th>Screen Name</th>
                        <th>Movie Name</th>
                        <th>Seats</th>
                        <th>FnB</th>
                        <th>Ticket Amount</th>
                        <th>FnB Amount</th>
                        <th>Booking source</th>
                        <th>Payment Mode</th>
                        <th>Refund Mode</th>
                    </thead>
                    <tbody v-if="bookedTransactions.length > 0">
                        <tr v-for="(bookedTransactionsObj, bookedTransactionsIndex) in bookedTransactions"
                            :key="bookedTransactionsIndex">
                            <td class="text-left"><b-form-checkbox class="ml-3 j-checkbox pb-0"
                                    v-model="bookedTransactionsObj.toRefund" unchecked-value="N" value="Y">{{
                                        bookedTransactionsObj.booking_code }}</b-form-checkbox></td>
                            <td class="text-left">{{ bookedTransactionsObj.screen_name }}</td>
                            <td class="text-left">{{ bookedTransactionsObj.movie_name }}-{{
                                bookedTransactionsObj.movie_format }}</td>
                            <td class="text-left wrapTableText">{{ bookedTransactionsObj.seat_name }}</td>
                            <td class="text-left">{{ bookedTransactionsObj.item_name || "-" }}</td>
                            <td class="text-right">{{ currFormat(bookedTransactionsObj.ticket_amount) }}</td>
                            <td class="text-right">{{ currFormat(bookedTransactionsObj.fnb_amount) }}</td>
                            <td class="text-right">{{ currFormat(bookedTransactionsObj.bs_source) }}</td>
                            <td class="text-right">{{ currFormat(bookedTransactionsObj.pm_payment_mode) }}</td>
                            <td class="text-right">
                                <div class="show-refund-container">
                                    <multiselect :key="`___${bookedTransactionsIndex}${bookedTransactionsIndex}`"
                                        :class="`___${bookedTransactionsIndex}${bookedTransactionsIndex}`"
                                        :disabled="isRoleID"
                                        :options="bookedTransactionsObj.refundApplicablePaymentModes"
                                        v-model="bookedTransactionsObj.showSelectedRefundMode" :searchable="true"
                                        label="pm_payment_mode" track-by="pm_id" placeholder="Refund Mode"
                                        :allowEmpty="false" :showLabels="false">
                                    </multiselect>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="11">
                                <NoRecords />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import ExhibitorService from "@/services/ExhibitorService";
import scheduleService from "@/services/scheduleService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import VueHtml2pdf from "vue-html2pdf";

export default {
    components: {
        NoRecords,
        VueHtml2pdf,
    },
    data() {
        return {
            BASEURL,
            isRoleID: false,
            submitted: false,
            dropDown: {
                cinemas: [],
                selectedCinema: null,
                selectedCinemaName: null,
                selectedCinemaId: "",
            },
            fromDate: new Date(),
            toDate: new Date(),
            bookedTransactions: [],
            showsList: [],
            selectedShowList: {},
            refundApplicablePaymentModes: [],
            selectedRefundMode: {},
            screensList: [],
            selectedScreen: {}
        };
    },
    beforeMount() {
        let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
        this.getCinemaList();
        this.getRefundPaymentModes()
        // this.getScreens()
        // if (CinemaObj) {
        //   this.onSelectCinema(CinemaObj);
        // }
    },
    watch: {
        // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        //   if (CinemaObj) {
        //     this.onSelectCinema(CinemaObj);
        //   }
        // },
        fromDate: async function () {
            this.screensList = []
            this.selectedScreen = {}
            this.selectedRefundMode = {}
            await this.getshowtimebyMovie('fromCinema')
        }
    },
    mounted() { },
    methods: {
        moment,
        onDateChange: async function () {
            console.log("date changed")
            // this.dropDown.selectedCinema = null;
            // this.dropDown.selectedCinemaName = null;
            // this.dropDown.selectedCinemaId = null;
            this.screensList = []
            this.selectedScreen = {}
            this.selectedRefundMode = {}
            await this.getshowtimebyMovie('fromCinema')
            // this.$store.dispatch("selectDropdownCinema", {});
        },
        getCinemaList: function () {
            MasterService.GetCinemas()
                .then((response) => {
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        this.dropDown.cinemas = data.Records;
                        this.CinemasCopy = data.Records;
                    } else {
                        this.$toasted.show(data.message);
                    }
                })
                .catch(this._CatchError);
        },
        onSelectCinema: async function (event) {
            this.dropDown.selectedCinema = event;
            this.dropDown.selectedCinemaName = event.cine_name;
            this.dropDown.selectedCinemaId = event.cine_id;
            this.$store.dispatch("selectDropdownCinema", event);
            await this.getshowtimebyMovie('fromCinema')
            // await this.getScreens()
        },
        getScreens: async function () {
            try {
                let payload = {
                    cinema_id: this.dropDown.selectedCinemaId,
                };
                const response = await scheduleService.GetScreens(payload);
                const { data } = response;
                if (data.status && data.Records.length) {
                    this.screensList = [...data.Records];
                    await this.getshowtimebyMovie()
                } else {
                    this.$toasted.show(data.message);
                }
            } catch (error) {
                console.log(error)
            }
        },
        getshowtimebyMovie: async function (initiator) {
            if (!this.fromDate && !this.dropDown.selectedCinemaId) return;
            if (initiator == "fromCinema") {
                this.screensList = []
                this.selectedScreen = {}
                this.selectedRefundMode = {}
            }
            this.showsList = []
            this.selectedShowList = {}
            let loader = this.$loading.show();
            let payload = {
                cinema_id: this.dropDown.selectedCinemaId,
                screen_id: this.selectedScreen.screen_id,
                // movie: this.movieid,
                ss_actual_start_date: moment(this.fromDate).format("YYYY-MM-DD"),
                screen_id: this.selectedScreen.hasOwnProperty("screen_id") ? this.selectedScreen.screen_id : null
            };
            // console.log("payload :", payload);
            const response = await scheduleService.GetTransactionsScheduleByDate(payload)
            console.log("response :", response);
            const { data } = response;
            loader.hide();
            if (data.status) {
                if (data.Records && data.Records.length > 0) {
                    this.showsList = data.Records;
                    if (!this.selectedScreen.hasOwnProperty("screen_id")) {
                        data.Records.forEach(screensObj => {
                            let isScreenExist = this.screensList.findIndex(screenDataObj => {
                                return screenDataObj.screen_id == screensObj.screen_id
                            })

                            if (isScreenExist < 0) {
                                this.screensList.push({ screen_id: screensObj.screen_id, screen_name: screensObj.screen_name })
                            }
                        })
                    }

                } else {
                    this.showsList = [];
                    this.screensList = []
                    // this.$toasted.show(`No Shows Found for this ${moment(this.fromDate).format("YYYY-MM-DD")}`);
                }
            } else {
                this.showsList = [];
                this.screensList = []
                this.$toasted.show(`No Shows Found for this ${moment(this.fromDate).format("YYYY-MM-DD")} `);
            }
        },
        getRefundPaymentModes: async function () {
            try {
                let payload = {
                    tableName: "ms_payment_modes",
                    pm_is_active: "Y",
                };
                const response = await MasterService.GetActiveList(payload);
                const { data } = response;
                if (data.status && data.Records.length) {
                    this.refundApplicablePaymentModes = [...data.Records.filter(paymentObj => {
                        return paymentObj.pm_is_refund_available == "Y"
                    })];
                } else {
                    this.$toasted.show(data.message);
                }
            } catch (error) {
                console.log(error)
            }
        },
        getBookedTransactions: async function () {
            if (!this.dropDown.selectedCinemaId) {
                return this.$toasted.show("Select Cinema");
            }
            if (!this.fromDate) {
                return this.$toasted.show("Select From Date");
            }
            if (!this.selectedShowList.ss_id) {
                return this.$toasted.show("Select shows")
            }
            let loader = this.$loading.show();
            let payload = {
                cinema_id: this.dropDown.selectedCinemaId,
                fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                toDate: moment(this.fromDate).format("YYYY-MM-DD"),
                ss_id: this.selectedShowList.ss_id
            };
            this.bookedTransactions = [];
            try {
                const response = await ExhibitorService.GetBookedTransactions(payload)

                const { data } = response;
                if (data.status && data.Records.length > 0) {
                    this.bookedTransactions = [...data.Records];
                    this.$toasted.show(data.message);
                } else {
                    this.$toasted.show(data.message);
                }
                loader.hide();
            } catch (error) {
                this._CatchError()
                loader.hide()
                console.log(error)
            }

        },
        makeBulkRefunds: async function () {
            let loader = this.$loading.show();
            try {
                let toRefundTransactions = this.bookedTransactions.filter(refundTransactionsObj => {
                    return refundTransactionsObj.toRefund == "Y"
                })
                if (!toRefundTransactions) return this.$toasted.show("Atleast one transaction needed to do refund")

                const response = await ExhibitorService.MakeBulkRefundTransactions({ toRefundData: toRefundTransactions, cinema_id: this.dropDown.selectedCinemaId })

                const { data } = response

                loader.hide()
                if (!data.status) return this.$toasted.show(data.message);
                return this.$toasted.show(data.message)
            } catch (error) {
                loader.hide()
                console.log(error)
            }
        },
        setRefundModes: function (event) {
            if (!this.bookedTransactions.length > 0) return

            this.bookedTransactions.forEach(bookedTransactionObj => {
                let refundModeExist = bookedTransactionObj.refundApplicablePaymentModes.some(refundObj => {
                    return refundObj.pm_id == event.pm_id
                })
                if (refundModeExist) {
                    bookedTransactionObj["showSelectedRefundMode"] = { ...this.selectedRefundMode }
                }
            })
        },
        setAllBookingsRefundStatus(option = "Y") {
            console.log(option)
            if (!this.bookedTransactions.length) return
            this.bookedTransactions.forEach(bookedTransactionsStatusObj => {
                bookedTransactionsStatusObj["toRefund"] = option
            })
        },
        makeRefunds: async function () {
            try {
                let refundDataArr = this.getBookedTransactions.filter(refundObj => {
                    return refundObj.showSelectedRefundMode && refundObj.showSelectedRefundMode.pm_id
                })

                if (!refundDataArr.length) return this.$toasted.show("Atleast one transaction needed to refund")


                refundDataArr.forEach(refundDataObj => {
                    refundDataObj["payment_mode_id"] = refundDataObj.showSelectedRefundMode.pm_id
                })
            } catch (error) {
                console.log(error, "from make refundds data")
            }
        }
    },
};
</script>
<style scoped>
.sectionName {
    padding: 5px 0px;
    color: #4a87e1;
}

.sectionName .fs-17 {
    font-size: 17px !important;
}

.text-small-instruction {
    font-weight: 400;
}

.text-red {
    color: red;
}

.percentText {
    color: black;
    font-size: 15px;
    font-weight: bold;
    position: relative;
    padding-inline: 8px;
}

.qtyInput {
    border-radius: 5px;
    border: 1px solid #777575;
    width: 80%;
    height: 30px;
}

.disable-field {
    cursor: not-allowed;
    opacity: 0.5;
}

.bor {
    border: 1px solid #b1b4b8;
    border-radius: 10px;
}

.back {
    background-color: #f5f5f5;
}

.inner-vendor-rate {
    background-color: #fff;
    border: 1px solid #b1b4b8;
    border-radius: 10px;
}

.po_item .multiselect__tags {
    border-radius: unset !important;
    border: unset !important;
}

.show-refund-input input {
    border: none;
    height: 40px;
    margin: 0;
    width: 100%;
    padding-inline: 10px;
}

.show-refund-input input::placeholder,
.show-refund-wrapper .multiselect__placeholder {
    font-size: 10px !important;
    font-style: italic !important;
}

.input_text-center input {
    text-align: center;
}

.input_text-right input {
    text-align: right;
}

.show-refund-wrapper .multiselect__placeholder {
    font-weight: unset !important;
    line-height: 25px;
}

.show_refund_input::placeholder {
    font-size: 10px !important;
    font-style: italic !important;
}

.noItemsClass {
    text-align: center;
    width: 100%;
    margin: 16px auto;
    font-size: 16px;
    line-height: 1.2;
    font-weight: 500;
}

.taxPopOver {
    zoom: 0.8;
    min-width: 200px;
}

.errRow {
    border: 2px solid red;
}

.borderNone {
    border: none !important;
}

.complete-tick {
    width: 120px;
    height: 120px;
    display: inline-block;
    background-size: contain;
}

.errorLine {
    color: red;
    border: 1px solid red;
}

.redLine {
    color: red !important;
}

.wrapTableText {
    white-space: normal !important
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShowRefund/showRefund.vue